module.exports = __webpack_public_path__ + "img/HTIT-WSL.1c65757b.jpg";